import React from 'react'
import { View, ViewStyle, TextStyle, Switch } from 'react-native'
import { Header, color, Text, spacing, iconArrowBack } from '@trivie/ui-mobile'
import { useStores } from '@trivie/core'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router'

export const SoundMusicScreen = observer(() => {
  const { userStore } = useStores()
  const { user } = userStore

  const history = useHistory()
  const goBack = () => history.goBack()

  if (!user) {
    return null
  }

  return (
    <View testID="SoundMusicScreen" style={FULL}>
      <div style={CONTAINER}>
        <Header
          leftIcon={iconArrowBack}
          onLeftPress={goBack}
          center
          style={HEADER}
          titleStyle={HEADER_TITLE}
          headerTx="Settings.Sounds.header"
        />

        <View
          style={{
            marginHorizontal: spacing[4],
            paddingVertical: spacing[4],
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            borderBottomColor: color.shade10,
          }}
        >
          <Text variant="label" tx="Settings.Sounds.fx" />
          <Switch
            // @ts-ignore
            dataSet={{ qat: `sound_effects_toggle` }}
            accessible
            accessibilityRole="switch"
            accessibilityLabel="[Sound Effects/Music]"
            trackColor={{ true: color.green, false: color.darkenGrey }}
            thumbColor="white"
            value={user.sounds_enabled || false}
            onValueChange={(value) => {
              userStore.updateUser({ sounds_enabled: value })
            }}
          />
        </View>

        <View
          style={{
            marginHorizontal: spacing[4],
            paddingVertical: spacing[4],
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Text variant="label" tx="Settings.Sounds.music" />
          <Switch
            // @ts-ignore
            dataSet={{ qat: `music_toggle` }}
            accessible
            accessibilityRole="switch"
            accessibilityLabel="[Sound Effects/Music]"
            trackColor={{ true: color.green, false: color.darkenGrey }}
            thumbColor="white"
            value={user.music_enabled || false}
            onValueChange={(value) => {
              userStore.updateUser({ music_enabled: value })
            }}
          />
        </View>
      </div>
    </View>
  )
})

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: React.CSSProperties = {
  backgroundColor: color.white,
}
const HEADER_TITLE: TextStyle = { fontSize: 24, color: color.black }
const HEADER: ViewStyle = { marginBottom: 37 }
